<template>
  <basic-container>
    <div class="protocol-management">
      <!-- 搜索区域 -->
      <div class="search-area">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="文档名称：">
            <el-input v-model="searchForm.name" placeholder="请输入文档名称" style="width: 200px;" clearable
              @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
          <el-form-item label="文档类型：">
            <el-select v-model="searchForm.type" placeholder="请选择或输入类型" style="width: 180px;" clearable
              filterable allow-create default-first-option>
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="action-area">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增文档</el-button>
      </div>

      <!-- 表格区域 -->
      <div class="table-area">
        <el-table :data="tableData" style="width: 100%" border v-loading="tableLoading">
          <el-table-column prop="name" label="文档名称" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="type" label="文档类型" width="160" align="center">
            <template slot-scope="scope">
              <el-tag size="small" :type="getTypeTagType(scope.row.type)">
                {{ getTypeLabel(scope.row.type) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180" align="center">
            <template slot-scope="scope">
              {{ formatTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="180" align="center">
            <template slot-scope="scope">
              {{ formatTime(scope.row.updateTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-view" @click="handleView(scope.row)" size="small">查看</el-button>
              <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row)" size="small"
                style="color: #409EFF;">编辑</el-button>
              <el-button type="text" icon="el-icon-delete" @click="handleDelete(scope.row)" size="small"
                style="color: #F56C6C;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页区域 -->
      <div class="pagination-area">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageInfo.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="pageInfo.total"></el-pagination>
      </div>

      <!-- 新增/编辑弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" fullscreen :close-on-click-modal="false"
        @close="handleDialogClose">
        <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="文档名称" prop="name">
                <el-input v-model="editForm.name" placeholder="请输入文档名称" maxlength="100" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文档类型" prop="type">
                <el-select v-model="editForm.type" placeholder="请选择或输入类型" style="width: 100%;"
                  filterable allow-create default-first-option>
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="文档内容" prop="content">
            <quill-editor v-model="editForm.content" ref="contentEditor" :options="editorOption"
              style="height: 500px;"></quill-editor>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 查看详情弹窗 -->
      <el-dialog title="文档详情" :visible.sync="viewDialogVisible" fullscreen @close="viewDialogVisible = false">
        <div class="view-detail">
          <div class="view-info">
            <div class="info-item">
              <span class="info-label">文档名称：</span>
              <span class="info-value">{{ viewDetail.name }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">文档类型：</span>
              <el-tag size="small" :type="getTypeTagType(viewDetail.type)">
                {{ getTypeLabel(viewDetail.type) }}
              </el-tag>
            </div>
            <div class="info-item">
              <span class="info-label">创建时间：</span>
              <span class="info-value">{{ formatTime(viewDetail.createTime) }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">更新时间：</span>
              <span class="info-value">{{ formatTime(viewDetail.updateTime) }}</span>
            </div>
          </div>
          <div class="view-content">
            <h4>文档内容：</h4>
            <div class="content-preview" v-html="viewDetail.content"></div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="viewDialogVisible = false">关 闭</el-button>
        </div>
      </el-dialog>
    </div>
  </basic-container>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {
  getDocumentList,
  getDocumentDetail,
  addDocument,
  updateDocument,
  deleteDocument
} from '@/api/salesCloud/document';

export default {
  name: 'ProtocolManagement',
  components: {
    quillEditor
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        name: '',
        type: ''
      },
      // 文档类型选项
      typeOptions: [
        { label: '隐私协议', value: 'privacy_policy' },
        { label: '用户协议', value: 'user_agreement' },
        { label: '关于我们', value: 'about_us' },
        { label: '服务协议', value: 'service_agreement' }
      ],
      // 表格数据
      tableData: [],
      tableLoading: false,
      // 分页
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      // 新增/编辑弹窗
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      submitLoading: false,
      editForm: {
        id: null,
        name: '',
        type: '',
        content: ''
      },
      editRules: {
        name: [{ required: true, message: '请输入文档名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择文档类型', trigger: 'change' }],
        content: [{ required: true, message: '请输入文档内容', trigger: 'blur' }]
      },
      // 富文本编辑器配置
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image']
          ]
        },
        placeholder: '请输入文档内容...'
      },
      // 查看详情弹窗
      viewDialogVisible: false,
      viewDetail: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 获取文档列表 */
    getList() {
      this.tableLoading = true;
      const params = {
        page: this.pageInfo.currentPage,
        size: this.pageInfo.pageSize
      };
      if (this.searchForm.name) {
        params.name = this.searchForm.name;
      }
      if (this.searchForm.type) {
        params.type = this.searchForm.type;
      }
      getDocumentList(params).then((res) => {
        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        if (data) {
          this.tableData = data.rows || [];
          this.pageInfo.total = data.total || 0;
        }
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    /** 搜索 */
    handleSearch() {
      this.pageInfo.currentPage = 1;
      this.getList();
    },
    /** 重置搜索 */
    handleReset() {
      this.searchForm = { name: '', type: '' };
      this.pageInfo.currentPage = 1;
      this.getList();
    },
    /** 新增 */
    handleAdd() {
      this.isEdit = false;
      this.dialogTitle = '新增文档';
      this.editForm = { id: null, name: '', type: '', content: '' };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.editFormRef && this.$refs.editFormRef.clearValidate();
      });
    },
    /** 编辑 */
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = '编辑文档';
      getDocumentDetail(row.id).then((res) => {
        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        this.editForm = {
          id: data.id,
          name: data.name,
          type: data.type,
          content: data.content || ''
        };
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.editFormRef && this.$refs.editFormRef.clearValidate();
        });
      });
    },
    /** 查看详情 */
    handleView(row) {
      getDocumentDetail(row.id).then((res) => {
        this.viewDetail = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        this.viewDialogVisible = true;
      });
    },
    /** 删除 */
    handleDelete(row) {
      this.$confirm('确认删除该文档吗？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDocument(row.id).then(() => {
          this.$message.success('删除成功');
          this.getList();
        });
      }).catch(() => {});
    },
    /** 提交新增/编辑 */
    handleSubmit() {
      this.$refs.editFormRef.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        const data = {
          name: this.editForm.name,
          type: this.editForm.type,
          content: this.editForm.content
        };
        const request = this.isEdit
          ? updateDocument({ ...data, id: this.editForm.id })
          : addDocument(data);
        request.then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功');
          this.dialogVisible = false;
          this.getList();
        }).finally(() => {
          this.submitLoading = false;
        });
      });
    },
    /** 弹窗关闭回调 */
    handleDialogClose() {
      this.editForm = { id: null, name: '', type: '', content: '' };
    },
    /** 分页 - 每页条数变化 */
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.pageInfo.currentPage = 1;
      this.getList();
    },
    /** 分页 - 页码变化 */
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val;
      this.getList();
    },
    /** 获取类型显示文本 */
    getTypeLabel(type) {
      const item = this.typeOptions.find((t) => t.value === type);
      return item ? item.label : type || '未知';
    },
    /** 获取类型标签颜色 */
    getTypeTagType(type) {
      const map = {
        privacy_policy: '',
        user_agreement: 'success',
        about_us: 'info',
        service_agreement: 'warning'
      };
      return map[type] || 'info';
    },
    /** 格式化时间戳 */
    formatTime(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.protocol-management {
  .search-area {
    margin-bottom: 10px;
  }
  .action-area {
    margin-bottom: 10px;
  }
  .pagination-area {
    margin-top: 15px;
    text-align: right;
  }
  .view-detail {
    .view-info {
      display: flex;
      flex-wrap: wrap;
      background: #f5f7fa;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 15px;
      .info-item {
        width: 50%;
        margin-bottom: 12px;
        font-size: 14px;
        display: flex;
        align-items: center;
        &:nth-last-child(-n+2) {
          margin-bottom: 0;
        }
      }
      .info-label {
        color: #909399;
        width: 80px;
        flex-shrink: 0;
      }
      .info-value {
        color: #303133;
      }
    }
    .view-content {
      margin-top: 20px;
      h4 {
        margin-bottom: 10px;
        color: #303133;
      }
      .content-preview {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        padding: 15px;
        min-height: 200px;
        max-height: 600px;
        overflow-y: auto;
        line-height: 1.8;
      }
    }
  }
}
</style>
